import { IndividualPolicy, IndividualApplication } from "IndividualApplication/types";
import { remove } from "lodash";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { baseURL } from "./urls";

const DENTAL_ELIGIBLE_STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WV",
  "WI",
  "WY",
];
const VISION_ELIGIBLE_STATES = [
  "AL",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MO",
  "MS",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "NV",
  "OH",
  "OK",
  "PA",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "WV",
  "WI",
  "WY",
];

export const sourceLocation = () => {
  const params: { source?: string; source_url?: string } = window.location.search
    .replace("?", "")
    ?.split("&")
    .reduce((a, b) => {
      const param = b.split("=");
      return {
        ...a,
        [`${param[0]}`]: param[1],
      };
    }, {});
  return {
    ...params,
    source_url: decodeURIComponent(params?.source_url),
  };
};

export const individualURLHelper = (url: string) => `${baseURL}${url}${window.location.search}`;

export const IndividualEligibilityHelper = (availablePlans, employeeForm) => {
  const ValidPlanTypes = ["dental", "vision"].filter((type) => availablePlans && !availablePlans.includes(type));

  if (ValidPlanTypes.includes("dental") && !DENTAL_ELIGIBLE_STATES.includes(employeeForm.state)) {
    remove(ValidPlanTypes, (t) => t == "dental");
  }
  if (ValidPlanTypes.includes("vision") && !VISION_ELIGIBLE_STATES.includes(employeeForm.state)) {
    remove(ValidPlanTypes, (t) => t == "vision");
  }
  return ValidPlanTypes;
};

export const individualEligibleDental = (individualApplication: IndividualApplication) => {
  return individualApplication?.offerDental && !individualApplication?.enrolledDental && DENTAL_ELIGIBLE_STATES.includes(individualApplication?.state);
};
export const individualEligibleVision = (individualApplication: IndividualApplication) => {
  return individualApplication?.offerVision && !individualApplication?.enrolledVision && VISION_ELIGIBLE_STATES.includes(individualApplication?.state);
};

export const AnalyticsEvent = (event) => {
  AnalyticsTracking.trackEvent(event, {
    location: sourceLocation() == "ee-application" ? "application" : "dashboard",
  });
};

export const EnrolledIndividualPlan = (individualPolicies: IndividualPolicy[] = [], type: string) => {
  let plan;
  individualPolicies.forEach((individualPolicy) => {
    if (individualPolicy.status === "enrolled") {
      if (
        (type === "dental" && individualPolicy.planType === "Individual::DentalPlan") ||
        (type === "vision" && individualPolicy.planType === "Individual::VisionPlan")
      ) {
        plan = individualPolicy.plan;
      }
    }
  });
  return plan;
};
